import React from 'react'
import { NavLink } from 'react-router-dom'

function NavItem(props) {
  return (
    <li><NavLink to={"/catalog/" +props.href}>{props.title}</NavLink></li>
  )
}

export default NavItem